export default "__VITE_ASSET__6ef448a0__"